const MENTION_MARKUP_REGEX = /@\[([^\]]+)\]\(([^)]+)\)/g;

export const parseMarkupToTipTapDoc = (markup = "") => {
  if (!markup) {
    return {
      type: "doc",
      content: [{ type: "paragraph" }],
    };
  }

  const lines = markup.split("\n");

  return {
    type: "doc",
    content: lines.map((line) => {
      const content = [];
      let lastIndex = 0;

      for (const match of line.matchAll(MENTION_MARKUP_REGEX)) {
        const [fullMatch, label, id] = match;
        const start = match.index ?? 0;

        if (start > lastIndex) {
          content.push({
            type: "text",
            text: line.slice(lastIndex, start),
          });
        }

        content.push({
          type: "mention",
          attrs: {
            id,
            label,
            mentionSuggestionChar: "@",
          },
        });

        lastIndex = start + fullMatch.length;
      }

      if (lastIndex < line.length) {
        content.push({
          type: "text",
          text: line.slice(lastIndex),
        });
      }

      return {
        type: "paragraph",
        content: content.length > 0 ? content : undefined,
      };
    }),
  };
};

export const serializeTipTapDocToMarkup = (doc) => {
  if (!doc?.content?.length) return "";

  return doc.content
    .map((node) => {
      if (node.type !== "paragraph") return "";

      if (!node.content?.length) return "";

      return node.content
        .map((child) => {
          if (child.type === "text") {
            return child.text || "";
          }

          if (child.type === "mention") {
            const label = child.attrs?.label || child.attrs?.id || "";
            const id = child.attrs?.id || "";
            return `@[${label}](${id})`;
          }

          if (child.type === "hardBreak") {
            return "\n";
          }

          return "";
        })
        .join("");
    })
    .join("\n");
};
